<template>
  <div>
    <Row style="margin-bottom: 20px">
      <Button type="primary" @click="add">添加到店结果</Button>
    </Row>
    <Table
      stripe
      :width="600"
      :loading="loading"
      border
      :columns="t_head"
      :data="t_data"
    ></Table>
    <Modal v-model="ModalShow" :title="title">
      <Form
        ref="formValidate"
        :model="formItem"
        :rules="ruleValidate"
        :label-width="80"
      >
        <FormItem label="到店结果" prop="result">
          <Input
            v-model="formItem.result"
            placeholder="请输入"
            @keydown.native.enter.prevent="handleEnter"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="close">取消</Button>
        <Button
          type="primary"
          size="large"
          @click="handleSubmit('formValidate')"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "resultSetting",
  data() {
    return {
      loading: false,
      ModalShow: false,
      title: "",
      formItem: {
        result: "",
        id: "",
      },
      ruleValidate: {
        result: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      t_head: [
        {
          type: "index",
          width: 60,
          align: "center",
          key: "id",
          title: "序号",
        },
        {
          title: "到店结果",
          key: "result",
          align: "center",
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: params.row.is_show == 1 ? "warning" : "error",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.show(params.row);
                    },
                  },
                },
                params.row.is_show == 1 ? "启用" : "未启用"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      console.log("params===>", params);
                      this.edit(params.row);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      t_data: [],
      listDetail: {},
    };
  },
  created() {
    this.apiReturnList();
  },
  methods: {
    handleEnter() {
      return false;
    },
    apiReturnList() {
      this.loading = true;
      serve
        .fetchGet(api.arrival_result_index, {})
        .then((data) => {
          this.t_data = data.list;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$Message.error(error.response.data.message);
        });
    },
    apiReturnAdd() {
      console.log("add");
      serve
        .fetchPost(api.arrival_result_add, this.formItem)
        .then((data) => {
          this.$Message.success("添加成功");
          this.ModalShow = false;
          this.apiReturnList();
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    apiReturnUpdate() {
      serve
        .fetchPost(
          api.arrival_result_update + "/" + this.formItem["id"],
          this.formItem
        )
        .then((data) => {
          this.$Message.success("编辑成功");
          this.ModalShow = false;
          this.apiReturnList();
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    apiReturnRemove(id) {
      serve
        .fetchPost(api.arrival_result_del + "/" + id, {})
        .then((data) => {
          console.log(data);
          this.$Message.success("删除成功");
          this.apiReturnList();
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    apiReturnInfo(id) {
      serve
        .fetchPost(api.arrival_result_edit + "/" + id, {})
        .then((data) => {
          this.ModalShow = true;
          this.formItem = data.arrival_result_config;
          console.log(data);
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    apiReturnShow(id) {
      serve
        .fetchPost(api.arrival_result_show + "/" + id, {})
        .then((data) => {
          this.$Message.success("修改成功");
          this.apiReturnList();
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    add() {
      // this.formItem = {
      //   result: "",
      //   id: 0,
      // };
      this.$refs.formValidate.resetFields();
      this.title = "添加到店结果";
      this.ModalShow = true;
    },
    edit(row) {
      console.log("row", row);
      this.$refs.formValidate.resetFields();
      this.title = "修改到店结果";
      // this.formItem = row;
      this.apiReturnInfo(row.id);
    },
    show(row) {
      this.apiReturnShow(row.id);
    },
    remove(id) {
      this.apiReturnRemove(id);
    },
    close() {
      this.ModalShow = false;
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.title === "添加到店结果") {
            this.apiReturnAdd();
            return;
          }
          this.apiReturnUpdate();
        } else {
          this.$Message.error("请完善表单");
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/Crm/ReturnManagement/resultSetting.vue